import { displayError } from '../helpers';
import { printPurchaseDebitNote } from '../services/PurchaseDebitNoteServices';
import { openPdfInApp } from './openPdfInApp';

async function parseApiError(error) {
    const responseData = error?.response?.data;
    if (responseData instanceof Blob) {
        try {
            const text = await responseData.text();
            try {
                return JSON.parse(text);
            } catch (parseError) {
                return { message: text || 'Failed to generate purchase debit note PDF.' };
            }
        } catch (readError) {
            return { message: 'Failed to generate purchase debit note PDF.' };
        }
    }
    return responseData || error;
}

export function fetchAndShowPurchaseDebitNotePdf(cookies, noteId, options = {}) {
    return printPurchaseDebitNote(cookies, noteId)
        .then((pdfResponse) => {
            openPdfInApp(pdfResponse, {
                title: options.title || 'Purchase Debit Note PDF',
                onClose: options.onClose,
            });
        })
        .catch(async (error) => {
            const parsedError = await parseApiError(error);
            displayError(parsedError || { message: 'Failed to generate purchase debit note PDF.' }, options.errorTitle || 'Print Failed');
        });
}
